import React, { useEffect, useState } from "react";
import { Box, Card, CardContent } from "@mui/material";
import { Button, DateField, FunctionField, Labeled, SimpleShowLayout, TopToolbar, useGetOne, useRedirect } from "react-admin";
import EditIcon from "@mui/icons-material/Edit";
import { Link, useParams } from "react-router-dom";
import { cleanTimeChoices, getNameAndCompanyNamewithAddress } from "../common";
import NoteAddIcon from '@mui/icons-material/NoteAdd';

const InspectHistoryShow = () => {
  const [record, setRecord] = useState(null);
  const [loading, setLoading] = useState(true);
  const { id } = useParams(); 
  const redirect = useRedirect();

  const { data, isLoading } = useGetOne("inspectHistory", { id });
  useEffect(() => {
    if(!isLoading && data){
      setRecord(data);
    }
  },[data,isLoading]);

  const CustomTopToolbar = () => (
    <Box sx={{ padding: 0, margin: 0 }}>
        <TopToolbar>
            <Button
                label="請求書を作成"
                onClick={() => redirect(`/invoice-form/inspectHistory/${id}`)}
                startIcon={<NoteAddIcon />}
            />
            <Button
                label="点検情報編集"
                onClick={() => redirect(`/inspectHistory/${id}`)}
                startIcon={<EditIcon />}
            />
        </TopToolbar>
    </Box>
  );

  const labelStyle = (text) => (
    <div style={{ backgroundColor: "#eee", color: "#666", paddingLeft: "5px" }}>
      {text}
    </div>
  );

  return (
    <>
      <CustomTopToolbar/>
      <Card>
        <CardContent>
            <SimpleShowLayout record={record}>
                {/* <FunctionField source="number" label={labelStyle("点検No")} style={{ paddingLeft: "5px" }} render={(record) => {
                  return String(record.number).padStart(5, "0");
                }}/> */}
                <DateField source="inspectDate" label={labelStyle("点検日")} style={{ paddingLeft: "5px" }} />
                {/* <div style={{display:"flex", justifyContent:"space-between",width:"100%"}}> */}
                  {/* <Labeled label={labelStyle("清掃予定日")} style={{ flex: 1, marginRight: "10px" }}>
                   <DateField source="exCleaningDate" label={labelStyle("点検日")} style={{ paddingLeft: "5px" }} />
                  </Labeled>
                  <Labeled label={labelStyle("清掃予定時間")} style={{ flex: 1, marginRight: "10px"}}>
                    <FunctionField source="exCleaningTime" label={labelStyle("清掃予定時間")} style={{ paddingLeft: "5px" }} 
                      render={record => {
                        const choice = cleanTimeChoices.find(choice => choice.id === record.exCleaningTime);
                        return choice ? choice.name : ""; 
                      }}
                    />
                  </Labeled> */}
                 <FunctionField source="staffName" label={labelStyle("担当者名")}  render={record => {return record.staffName}} />
                {/* </div> */}
                <FunctionField source="content" label={labelStyle("点検内容")} style={{ paddingLeft: "5px" }} render={record => {return record.content}} />
                <div style={{display:"flex", justifyContent:"space-between",width:"100%"}}>
                  <Labeled label={labelStyle("清掃が必要かどうか")} style={{ flex: 1 , marginRight: "5px"}}>
                    <FunctionField 
                      source="needsCleaning" 
                      label={labelStyle("清掃が必要かどうか")} 
                      style={{ paddingLeft: "5px"}} 
                      render={record => {
                        if (record.needsCleaning) return "清掃必要";
                        if (!record.needsCleaning) return "清掃不要";
                        return "未設定";
                      }} 
                    />
                  </Labeled>
                  <Labeled label={labelStyle("採水かどうか")} style={{ flex: 1 , marginLeft: "5px"}}>
                    <FunctionField 
                      source="isSampling" 
                      label={labelStyle("採水かどうか")} 
                      style={{ paddingLeft: "5px" }} 
                      render={record => {
                        if (record.isSampling) return "採水あり";
                        if (!record.isSampling) return "採水なし";
                        return "未設定";
                      }} 
                    />
                  </Labeled>

                </div>
                <FunctionField
                  source="customerId"
                  label={labelStyle("顧客名")} 
                  style={{ paddingLeft: "5px" }}
                  render={(record) => {
                    return <Link to={`/customers-inspect/show/${record.customerId}`}>{getNameAndCompanyNamewithAddress(record)}</Link>;
                  }}
                />
                <FunctionField
                  source="invoiceId"
                  label={labelStyle("請求情報")} 
                  style={{ paddingLeft: "5px" }}
                  render={(record) => {
                    return <Link to={`/invoiceHistory/show/${record.invoiceId}`}>{record.invoiceNumber && <>請求詳細はこちら</>}</Link>;
                  }}
                />
                <DateField source="createDate" label={labelStyle("登録日")} style={{ paddingLeft: "5px" }} />
                <DateField source="updateDate" label={labelStyle("更新日")} style={{ paddingLeft: "5px" }} />
            </SimpleShowLayout>
        </CardContent>
      </Card>
    </>

  );
};

export default InspectHistoryShow;

